import { defineComponent as _defineComponent } from 'vue'
import CardContainer from '@/components/card-container.vue';
import CardContentLoader from '@/components/card-content-loader.vue';
import { RETURN_USER_DIALOG } from '@/config/dialog-manager-config';
import { useDialogManager } from '@/hooks/use-dialog-manager';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { useReturningUserStore } from '@/store/returning-user-module';
import { biBrow } from '@tencent/fit-bi-sdk';
import { elk } from '@tencent/ppd-base-libs';
import { CouponState } from '@tencent/wphk-act-base-components';
import { to } from '@tencent/wphk-base-utils';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import { ActState } from '@tencent/wphk-components-returning-user/business/returnCodeAct';
import { ScreenDialog } from '@tencent/wphk-ui';
import { computed, onMounted, ref, toRefs, watchEffect, onBeforeUnmount } from 'vue';
import { getReturnDialogMark, setReturnDialogMark } from './business/dialog-mark';
import ReturningActDialog from './components/returning-act-dialog.vue';
import RewardHeader from './components/reward-header.vue';
import RewardList from './components/reward-list.vue';
import RewardResult from './components/reward-result.vue';
import { useBiReport } from './hooks/use-report';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { ModuleName } from '@/types/module-config';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['initDone'],
  setup(__props, { emit }) {


const isLoadFinish = ref(false);
const returningUserStore = useReturningUserStore();
const { showWithDialogManager, hideWithDialogManager } = useDialogManager();
const { canJoinAct,
  hasSelectedTargetAwardCode,
  returnCodeActInfo,
  mrchConfig,
  rewardCoupon,
} = toRefs(returningUserStore);
const returningActDialog = ref<InstanceType<typeof ScreenDialog>>();
const isShowModule = computed(() => {
  // 是否能/已经参与活动：能参与活动且配置未过期；是当前商户的回流券且券能用
  // 不是abt的券
  const isValidAct = (canJoinAct.value && mrchConfig?.value.isValid) || isTargetCouponCanUse.value;
  // 优惠券不为空
  const isValidCoupon = rewardCoupon?.value.coupon;
  const isABTCoupon = !!rewardCoupon?.value.coupon?.abtGroup;
  console.log('====isShowModule', isLoadFinish.value, isValidCoupon, mrchConfig?.value.isValid, canJoinAct.value, isTargetCouponCanUse.value);
  console.log('====isShowModule isValidAct', isValidAct);
  console.log('====isShowModule isABTCoupon:', isABTCoupon);
  return isLoadFinish.value && isValidCoupon && isValidAct && !isABTCoupon;
});
// eslint-disable-next-line max-len
const isTargetCouponCanUse = computed(() => hasSelectedTargetAwardCode.value && rewardCoupon?.value.coupon?.couponState === CouponState.received);
const unreceivedAct = computed(() => ActState.UNRECEIVED === returnCodeActInfo.value.actState);
const headerAmount = computed(() => rewardCoupon.value.coupon?.discount);
const { biExt } = useBiReport();
const { getBiExt } = useGlobalBi();
const { isMall } = useMerchantInfo();

const elkReport = () => {
  elk({
    key: 'giftPackReturningUser',
    msg: `isShowModule:${isShowModule}`,
    str1: `isValidCoupon:${!!rewardCoupon.value?.coupon}`,
    str2: `isValidMrchConfig:${!!mrchConfig.value?.isValid}`,
    str3: `canJoinAct:${canJoinAct}`,
    str4: `isTargetCouponCanUse:${isTargetCouponCanUse}`,
  });
};

watchEffect(async () => {
  if (hasSelectedTargetAwardCode.value) {
    await returningUserStore.getInitCoupon();
  }
});

const showReturnDialog = showWithDialogManager(RETURN_USER_DIALOG, () => {
  (returningActDialog?.value as any)?.showDialog();
  setReturnDialogMark();
});

const hideReturnDialog = hideWithDialogManager(RETURN_USER_DIALOG, () => {
});

const checkAndShowReturnDialog = () => {
  if (isShowModule.value && unreceivedAct.value && !getReturnDialogMark()) {
    // 未領取回流碼的用戶才彈出（領取中，已領取不彈出）
    showReturnDialog();
  }
};

// 初始化回流活动组件
onMounted(async () => {
  await to(returningUserStore.init());
  isLoadFinish.value = true;
  // 展示回流弹窗
  checkAndShowReturnDialog();
  // 通知外部初始化完毕。与弹窗管理器有关
  emit('initDone', { moduleName: ModuleName.ReturnUserModule });
  // 埋点与上报
  if (isShowModule.value) {
    biBrow('userbackpage.userbackpage_brow', { ...getBiExt(), ...biExt.value });
  }
  elkReport();
  // 领取回流优惠券跳转原生刷卡场景，付款完毕之后返回需要刷新页面
  document.addEventListener('visibilitychange', returningUserStore.init);
});

onBeforeUnmount(() => {
  document.removeEventListener(
    'visibilitychange',
    returningUserStore.init,
  );
});



return { __sfc: true,emit, isLoadFinish, returningUserStore, showWithDialogManager, hideWithDialogManager, canJoinAct, hasSelectedTargetAwardCode, returnCodeActInfo, mrchConfig, rewardCoupon, returningActDialog, isShowModule, isTargetCouponCanUse, unreceivedAct, headerAmount, biExt, getBiExt, isMall, elkReport, showReturnDialog, hideReturnDialog, checkAndShowReturnDialog, CardContainer, CardContentLoader, BaseComponent, ReturningActDialog, RewardHeader, RewardList, RewardResult }
}

})